import React, { useEffect, useRef, useState } from 'react'
import { Toast } from 'antd-mobile-v5'
import { DownOutline, UpOutline } from 'antd-mobile-icons'
import { useHistory } from 'react-router-dom'
import { isWechat } from '../../utils/wechat'
import { useDownloadWallCert } from '../../services/hooks'
import { CLUB_URL_DOMAIN } from '../../utils/env'
import { UClick } from '../common/utils'
import { isFdCert } from '../../utils/cert'
import styles from './CertShowWrapper.module.css'

const CertDetailPanel = ({ cert, isClubVip, currentCardDetail, hasChangeRight }) => {
  const { loading, run: download } = useDownloadWallCert()
  const { push } = useHistory()
  const [isOpen, setIsOpen] = useState(true)
  const [contentHeight, setContentHeight] = useState(0)
  const contentRef = useRef(null)
  const { affiliateCredentialId, affiliateCertificationId, certificationName, encodedId, ecardName } = cert

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight)
    }
  }, [isOpen])

  const downLoadWallCert = () => {
    if (isWechat()) {
      Toast.show({ content: '请在浏览器中打开，下载墙上证书' })
    } else {
      let data
      if (affiliateCertificationId) data = { affiliateCertificationId, ecardType: 'CERTIFICATION' }
      else data = { affiliateCredentialId, ecardType: 'CREDENTIAL' }
      download(data)
    }
  }

  const toogle = () => {
    contentRef.current.style.transition = 'height 0.2s ease'
    setIsOpen(!isOpen)
  }

  const toBuyCards = () => {
    UClick('clickPanelBuyCards')
    // currentCardDetail 可能尚未加载（初始为 null），此时仅传 ecardId
    const cardImageName = currentCardDetail?.desc
    push('/buy_cards', { ecardId: encodedId, cardImageName })
  }

  const toClub = () => {
    UClick('panelToMemberCenter')
    window.location.href = CLUB_URL_DOMAIN + '/pages-mine/mine/member-center?pageVipId=1'
  }

  const goToCustomize = () => {
    UClick('clickCardCustomize')
    push(`/mermaid/upload?ecard_id=${encodedId}&ecard_name=${ecardName}`, { ecard: cert })
  }

  return (
    <>
      <div
        className={styles.panel}
        ref={contentRef}
        style={{
          height: isOpen ? `${contentHeight}px` : '0',
          overflow: 'hidden',
        }}
      >
        <div className={styles['panel-item']}>
          <div className={styles.left}>
            <div className={styles.title}>{hasChangeRight ? '点击购买实体卡面' : '点击购买卡面'}</div>
            <div className={styles.desc}>丰富卡面任您挑选，助力PADI海洋公益</div>
          </div>
          <div className={styles.right} onClick={toBuyCards}>
            立即购买
          </div>
        </div>
        {!hasChangeRight && (
          <div className={styles['panel-item']}>
            <div className={styles.left}>
              <div className={styles.title}>加入PADI CLUB SVIP会员所有电子卡面畅换</div>
              <div className={styles.desc}>更享免费领取一张实体卡</div>
            </div>
            <div className={styles.right} onClick={toClub}>
              加入会员
            </div>
          </div>
        )}
        {(affiliateCredentialId || certificationName === 'Mermaid Performance Diver') && (
          <div className={styles['panel-item']}>
            <div className={styles.left}>
              <div className={styles.title}>下载展示专业证书</div>
            </div>
            <div className={styles.right} onClick={downLoadWallCert}>
              墙上证书
            </div>
          </div>
        )}
        {isFdCert(cert) && (
          <div className={styles['panel-item']}>
            <div className={styles.left}>
              <div className={styles.title}>自定义卡面</div>
              <div className={styles.desc}>创作属于您的电子卡面</div>
            </div>
            <div className={styles.right} onClick={goToCustomize}>
              立即查看
            </div>
          </div>
        )}
      </div>
      <div className={styles['panel-control-box']}>
        {isOpen ? (
          <div className={styles['panel-control']} onClick={toogle}>
            <div className={styles.text}>收起</div>
            <UpOutline fontSize={12} color="#ffffff" />
          </div>
        ) : (
          <div className={`${styles['panel-control']} ${styles['panel-control-close']}`} onClick={toogle}>
            <div className={styles.text}>实体卡面购买</div>
            <DownOutline fontSize={12} color="#ffffff" />
          </div>
        )}
      </div>
    </>
  )
}

export default CertDetailPanel
